import React from 'react';
import SimpleSelect from 'react-select';
import {
  leadItemStatuses,
  itemOfferChoices,
  openOfferStatuses,
  declinedItemStatuses,
} from 'constants/leadStatuses';
import { getItemSelection } from '../utils/getItemSelection';

const LeadItemSelection = ({
  lead,
  item,
  itemSelections,
  handleItemSelection,
  formatLabel,
}) => {
  if (!openOfferStatuses.includes(lead.status)) {
    const statusDisplay = (() => {
      if (declinedItemStatuses.includes(item.status)) {
        return 'Declined';
      }
      if (
        item.status === leadItemStatuses.ACCEPTED ||
        item.status === leadItemStatuses.RECEIVED
      ) {
        if (item.consignment == null) {
          return 'Not selected';
        }
        return item.consignment ? 'Consignment' : 'Cash';
      }
      return '';
    })();

    return <div className="text-gray-700">{statusDisplay}</div>;
  }

  const selection = getItemSelection(item, itemSelections[lead.id]);

  const selectionValueLabel = selection
    ? { value: selection, label: formatLabel(selection) }
    : null;

  return (
    <SimpleSelect
      isMulti={false}
      isSearchable={false}
      placeholder="Select an option"
      components={{ IndicatorSeparator: () => null }}
      options={[
        ...(item.consignment_price
          ? [{ value: itemOfferChoices.CONSIGNMENT, label: 'Consignment' }]
          : []),
        ...(item.cash_price
          ? [{ value: itemOfferChoices.CASH, label: 'Cash' }]
          : []),
        { value: itemOfferChoices.DECLINE, label: 'Decline' },
      ]}
      onChange={(selectedOption) =>
        handleItemSelection(lead.id, item.id, selectedOption.value)
      }
      value={selectionValueLabel}
      styles={{
        control: (provided, state) => ({
          ...provided,
          border: 'none',
          borderBottom: '1px solid black',
          borderRadius: 'none',
          boxShadow: 'none',
          background: 'transparent',
          borderColor: state.isFocused ? 'grey' : 'black',
          '&:hover': {
            borderBottom: '2px solid grey',
          },
        }),
        indicatorSeparator: () => ({
          display: 'none',
        }),
        option: (provided) => ({
          ...provided,
          backgroundColor: '#f9f9f9',
          color: 'black',
          ':hover': {
            backgroundColor: 'black',
            color: 'white',
          },
          padding: 5,
        }),
        menu: (provided) => ({
          ...provided,
          marginTop: -2,
          borderRadius: '2px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: 'black',
        }),
      }}
    />
  );
};

export default LeadItemSelection;
